import {Component, computed, inject} from '@angular/core';
import {TaAppStore} from '../../../../state/clcta-store';
import {ActivatedRoute, Router} from '@angular/router';
import {CreateTaStep, CreateTaStepType} from '../../../../util/app.types';
import {TimelineStepComponent} from './timeline-step.component';


@Component({
  selector: 'create-ta-timeline',
  imports: [
    TimelineStepComponent
  ],
  templateUrl: './create-ta-timeline.component.html',
  styleUrl: './create-ta-timeline.component.scss'
})
export class CreateTaTimelineComponent {
  store = inject(TaAppStore);
  router = inject(Router);
  route = inject(ActivatedRoute);
  currentCreateTaStep = computed<CreateTaStep>(() => this.store.currentCreateTaStep());
  submissionId = computed<string>(() => {
    if (this.store.taSubmission()?.id) {
      return this.store.taSubmission()!.id!.toString();
    } else {
      return 'new';
    }
  });

  setStep(step: CreateTaStep) {
    const currentStepType: CreateTaStepType = this.store.currentCreateTaStep.code();
    if (currentStepType === CreateTaStepType.REVIEW && step.code !== CreateTaStepType.REVIEW) {
      this.router.navigate(['/ta/' + this.submissionId()], {
        queryParams: { step: step.code },
        queryParamsHandling: 'merge',
      });
    } else if (step.code === CreateTaStepType.REVIEW) {
      this.router.navigate(['ta/' + this.submissionId() + '/review']);
    } else {
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { step: step.code },
        queryParamsHandling: 'merge',
      });
    }
  }
}
